import { useRef, useEffect } from 'react';

const MARQUEE_ITEMS = [
  { label: 'Rhino 3D', type: 'software' },
  { label: 'ZBrush', type: 'software' },
  { label: 'Blender', type: 'software' },
  { label: 'UPI', type: 'payment' },
  { label: 'GPay', type: 'payment' },
  { label: 'Paytm', type: 'payment' },
  { label: 'Visa', type: 'payment' },
  { label: 'Mastercard', type: 'payment' },
  { label: 'RuPay', type: 'payment' },
];

function MarqueeItem({ item }) {
  const isSoftware = item.type === 'software';
  return (
    <div className="flex items-center gap-3 px-5 py-2.5 mx-2 shrink-0 rounded-full" style={{ background: '#FFFFFF', border: '1px solid rgba(0,0,0,0.06)' }}>
      <span className="font-mono text-sm font-medium whitespace-nowrap" style={{ color: isSoftware ? '#c88a5e' : '#666' }}>
        {item.label}
      </span>
      {isSoftware && (
        <span className="text-[10px] uppercase tracking-widest text-[#aaa] font-body">Compatible</span>
      )}
    </div>
  );
}

export default function SocialProofBar() {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let pos = 0;
    const speed = 0.5;
    let rafId;
    const scroll = () => {
      pos -= speed;
      const halfWidth = track.scrollWidth / 2;
      if (Math.abs(pos) >= halfWidth) pos = 0;
      track.style.transform = `translateX(${pos}px)`;
      rafId = requestAnimationFrame(scroll);
    };
    rafId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(rafId);
  }, []);

  const tripled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <section
      data-testid="social-proof-bar"
      className="relative overflow-hidden py-6"
      style={{ background: '#FFFFFF' }}
    >
      <div className="absolute left-0 top-0 bottom-0 w-20 z-10 pointer-events-none" style={{ background: 'linear-gradient(to right, #FFFFFF, transparent)' }} />
      <div className="absolute right-0 top-0 bottom-0 w-20 z-10 pointer-events-none" style={{ background: 'linear-gradient(to left, #FFFFFF, transparent)' }} />

      <div className="text-center mb-3">
        <span className="uppercase text-[10px] tracking-[0.3em] font-bold font-body text-[#aaa]" data-testid="social-proof-label">
          Works with your tools &bull; Secure Checkout &bull; 100% Safe &amp; Secure
        </span>
      </div>

      <div className="overflow-hidden">
        <div ref={trackRef} className="flex will-change-transform" data-testid="social-proof-marquee">
          {tripled.map((item, i) => (
            <MarqueeItem key={`${item.label}-${i}`} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
